import React from 'react';

const DEFAULT_ROWS = 10;

export interface BestCompaniesHubListSkeletonProps {
  rows?: number;
}

/**
 * Placeholder list while hub rankings load on client-side navigation (Vike data + API fallback).
 */
export function BestCompaniesHubListSkeleton({
  rows = DEFAULT_ROWS,
}: BestCompaniesHubListSkeletonProps): React.ReactElement {
  return (
    <ol className="space-y-2 max-w-3xl sm:space-y-3" aria-busy="true" aria-label="Loading employer rankings">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i}>
          <div className="flex items-start gap-2.5 rounded-xl border border-jc-border bg-jc-surface p-3 shadow-md sm:gap-4 sm:rounded-2xl sm:p-4 animate-pulse">
            <div className="w-5 shrink-0 pt-1 sm:w-6 sm:pt-2">
              <div className="mx-auto h-3 w-4 rounded bg-jc-elevated dark:bg-jc-elevated" />
            </div>
            <div className="h-12 w-12 shrink-0 rounded-lg bg-jc-elevated dark:bg-jc-elevated" />
            <div className="min-w-0 flex-1 space-y-2">
              <div className="flex justify-between gap-2">
                <div className="h-4 max-w-[60%] rounded bg-jc-elevated dark:bg-jc-elevated" />
                <div className="h-9 w-9 shrink-0 rounded-md bg-jc-elevated dark:bg-jc-elevated sm:h-10 sm:w-10 sm:rounded-lg" />
              </div>
              <div className="h-3 max-w-[45%] rounded bg-jc-elevated/80 dark:bg-jc-elevated/80" />
              <div className="h-3 max-w-[85%] rounded bg-jc-elevated/60 dark:bg-jc-elevated/60" />
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
